// Initialize Bootstrap components that require JavaScript
document.addEventListener('DOMContentLoaded', function () {
    // Initialize all popovers
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach(function (element) {
        new bootstrap.Popover(element, { html: true });
    });
    
    // Initialize all tooltips
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (element) {
        new bootstrap.Tooltip(element);
    });
});
